import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { installLegacyApiBridge } from "./services/legacy-api-bridge";
import { activateWindowsTabGuard } from "./services/windows-tab-guard";
import "../../app/globals.css";

function renderGuardScreen(reason) {
  const root = document.getElementById("root");
  if (!root) return;
  const night = reason === "night";
  root.innerHTML = `<main class="windows-tab-guard" role="status">
    <div class="windows-tab-guard-card">
      <span>${night ? "🌙" : "🖥️"}</span>
      <h1>${night ? "Portail fermé pour la nuit" : "Le portail est déjà ouvert"}</h1>
      <p>${night ? "Sur les postes Windows, le portail est automatiquement arrêté de 22 h 00 à 6 h 30." : "Cet onglet est neutralisé. La page demandée a été transmise à l’onglet déjà actif sur ce poste."}</p>
      <small>${night ? "L’onglet va se fermer automatiquement." : "Vous pouvez revenir à l’onglet Portail Pharma déjà ouvert."}</small>
    </div>
  </main>`;
}

async function startPortal() {
  const guard = await activateWindowsTabGuard();
  if (!guard.allowed) {
    renderGuardScreen(guard.reason);
    guard.close?.();
    return;
  }
  installLegacyApiBridge();
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void startPortal();
